/* eslint-disable max-len */
import React from 'react';
import questionnaireImg from '../../static/images/illustrations/questionnaire.png';
import miniaturePro from '../../static/images/section2-collecte/miniature2.jpg';
import miniatureChild from '../../static/images/section2-collecte/miniature1.jpg';
import pdfPro from '../../static/images/section2-collecte/infographie-bridge-pro.pdf';
import pdfChild from '../../static/images/section2-collecte/infographie-bridge-child.pdf';

export const Section2Collecte = () => (
  <section id="section2-collecte">
    <h2 className="titre-collecte-donnees pt-8 pb-4">Collecte de données</h2>
    <div className="flex pt-4 flex-col md:flex-row justify-center items-center">
      <div className="img-container w-full md:w-1/2">
        <img src={questionnaireImg} alt="illustration questionnaire" />
      </div>
      <div className="text-container w-full md:w-1/2 py-4">
        <p className="px-8 mb-4 md:mb-2 lg:mb-4 xl:mb-8">
          Afin de mieux comprendre la conception, la prévalence et la prise en charge des VBG en Belgique, nous avons mené trois collectes de données auprès d’enfants migrant·e·s et de professionnel·le·s des centres d’accueil (Fedasil, Croix-Rouge) et d’autres associations.
        </p>
        <p className="px-8">Deux infographies synthétisent les résultats obtenus. Télécharger l’infographie adaptée aux enfants et celle des professionnel·le·s. </p>
      </div>
    </div>
    <div className="images-collecte-pdf flex flex-col md:flex-row justify-between items-center">
      <div className="pdf-container">
        <a href={pdfPro} target="_blank" rel="noreferrer">
          <img src={miniaturePro} alt="pdf1" />
        </a>
      </div>
      <div className="pdf-container">
        <a href={pdfChild} target="_blank" rel="noreferrer" className="br-20">
          <img src={miniatureChild} alt="pdf2" />
        </a>
      </div>

    </div>
  </section>

);
